import { Controller } from "@hotwired/stimulus";

// Shows exactly as many variable inputs as the selected WhatsApp template
// requires. Fields beyond that count are hidden AND disabled: a merely
// hidden <input> is still submitted with the form, so disabling is what
// actually keeps unused slots out of the `variables[]` array the server
// validates the count of.
export default class extends Controller {
  static targets = ["select", "variableField", "variableInput"];

  connect() {
    this.update();
  }

  change() {
    this.update();
  }

  update() {
    const option = this.selectTarget.selectedOptions[0];
    const required = option ? Number(option.dataset.requiredVariables || 0) : 0;

    this.variableFieldTargets.forEach((field, index) => {
      const visible = index < required;
      field.hidden = !visible;
    });

    this.variableInputTargets.forEach((input, index) => {
      const visible = index < required;
      input.disabled = !visible;
      input.required = visible;
      if (!visible) input.value = "";
    });
  }
}
